module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Node")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Node")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Latitude / Longitude")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.value),
      expression: "form.latitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "90",
      "placeholder": "0 - 90"
    },
    domProps: {
      "value": (_vm.form.latitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.latitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.orientation),
      expression: "form.latitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.latitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("North")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("South")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.value),
      expression: "form.longitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "180",
      "placeholder": "0 - 180"
    },
    domProps: {
      "value": (_vm.form.longitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.longitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.orientation),
      expression: "form.longitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.longitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("East")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("Online")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUSPENDED"
    }
  }, [_vm._v("Suspended")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/nodes"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Nodes")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("This table shows the registered DAPNET Core nodes and is mostly for SysOp information.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1e6928"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/node/New.vue
// module id = 628
// module chunks = 1